import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {ScrollTargetDirective} from '@domain/common/directive/scroll-target.directive';
import {ScrollToDirective} from '@domain/common/directive/scroll-to.directive';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-about',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    ScrollTargetDirective,
    ScrollToDirective,
    RouterLink
  ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {

  public readonly routes = {
    publish: RouteGenerator.abs(UI_ROUTES.public.activity.publish),
    dashboard: RouteGenerator.abs(UI_ROUTES.public.dashboard)
  };
}
